import { IAlert } from 'app/shared/model/alert.model';
import { ISensorData } from 'app/shared/model/sensor-data.model';

export interface IAlertActivation {
  id?: number;
  lat?: string | number | null;
  lon?: string | number | null;
  alert?: IAlert | null;
  truckImplementId?: number | null;
  created?: Date | null;
  sensorValue?: number | null;
}

export const defaultValue: Readonly<IAlertActivation> = {};
